export const ALERTS_LIST_DEFAULT = [
  {
    query: '/api/v1/products?alert=UNPUBLISHED',
    severity: 'ERROR',
    kind: 'UNPUBLISHED',
    count: null,
  },
  {
    query: '/api/v1/products?alert=REPROVED',
    severity: 'WARNING',
    kind: 'REPROVED',
    count: null,
  },
  {
    query: '/api/v1/products?alert=WITHOUT_STOCK',
    severity: 'ERROR',
    kind: 'WITHOUT_STOCK',
    count: null,
  },
  {
    query: '/api/v1/products?alert=LOW_STOCK',
    severity: 'WARNING',
    kind: 'LOW_STOCK',
    count: null,
  },
  {
    query: '/api/v1/products?alert=FULFILLMENT_ACTIVE',
    severity: 'INFO',
    kind: 'FULFILLMENT_ACTIVE',
    count: null,
  },
  {
    query: '/api/v1/products?alert=PROMOTIONAL_PRICE',
    severity: 'INFO',
    kind: 'PROMOTIONAL_PRICE',
    count: null,
  },
]
